import { render, staticRenderFns } from "./staticContract.vue?vue&type=template&id=d84112e2&scoped=true&"
import script from "./staticContract.vue?vue&type=script&lang=js&"
export * from "./staticContract.vue?vue&type=script&lang=js&"
import style0 from "./staticContract.vue?vue&type=style&index=0&id=d84112e2&scoped=true&lang=css&"
import style1 from "./staticContract.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84112e2",
  null
  
)

export default component.exports